<div class="tag-management-dialog-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>{{ ('BUTTON.' + data.mode | translate) + ' ' + (data.type + '.TITLE' | translate) }}</span>
		<button mat-icon-button (click)="closeDialog()" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-3">
		@if (data.mode === 'NEW' || data.mode === 'EDIT') {
		<!-- Create/Edit Category/Tag -->
		<form class="pt-3 mx-3" [formGroup]="formGroup" (keydown.enter)="action()">
			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.TITLE' | translate }}</mat-label>
					<input matInput type="text" formControlName="value" cdkFocusInitial />
					@if (data.type === 'TAG' && data.typeWithScope === 'tag_transcriptions') {
					<mat-hint>{{ 'TAG.KEYWORD_SEARCH_HINT' | translate }}</mat-hint>
					}
				</mat-form-field>
			</div>

			@if(data.type === 'TAG') {
			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.CATEGORY' | translate }}</mat-label>
					<select id="categoryId" style="display: none"></select>
					<!-- workaround for material-chrome bug -->
					<mat-select id="categoryId" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="categoryId">
						@for (category of categories; track $index) {
						<mat-option [value]="category.id">{{ category.value }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>

			<div class="row pb-3">
        <div class="col ms-1 d-flex align-items-center">
					<ngx-colors ngx-colors-trigger style="display: inline-block; margin: 5px" formControlName="colorCode"></ngx-colors>
					<span>{{ data.type + '.COLOR' | translate }} {{ ' ' + formGroup.controls['colorCode'].value ? formGroup.controls['colorCode'].value : '' }}</span>
				</div>

				@if (data.typeWithScope === 'tag_clipping') {
				<mat-checkbox class="col d-flex align-items-center" color="primary" formControlName="fill">
					<span>{{ data.type + '.FILL' | translate }}</span>
				</mat-checkbox>

				<mat-checkbox class="col d-flex align-items-center" color="primary" formControlName="screenshot">
					<span>{{ data.type + '.SCREENSHOT' | translate }}</span>
				</mat-checkbox>
      }
			</div>

			@if (data.typeWithScope === 'tag_clipping') {
			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.TRANSLATION_LANGUAGES' | translate }}</mat-label>
					<select id="langs" style="display: none"></select>
					<!-- workaround for material-chrome bug -->
					<mat-select id="langs" color="primary" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="langs" multiple>
						@for (language of availableLanguages; track $index) {
						<mat-option [value]="language.code.toUpperCase()">{{ 'NAVBAR.LANGUAGES.' + language.code.toUpperCase() | translate }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>
			} } @for(langCode of avaliableLanguagesCodes; track $index) {
			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.NAME' | translate }}</mat-label>
					<input matInput type="text" [formControlName]="'name' + (langCode | titlecase)" />
					<button class="me-1" mat-icon-button matSuffix type="button" disabled>
						<img [src]="externalAssets + '/flags/' + langCode + '.svg'" />
					</button>
				</mat-form-field>
			</div>
			}
		</form>
		<!-- (END)Create/Edit Category/Tag -->
		} @else if (data.mode === 'DELETE') {
		<span> {{ 'ASSORTED.DELETE_CONFIRMATION_MESSAGE' | translate }} {{ data.item.value }}? </span>
		} @else if (data.mode === 'DELETE_REASSIGN') {
		<div class="pb-2">
			<span> {{ 'ASSORTED.DELETE_CONFIRMATION_MESSAGE' | translate }} {{ data.item.value }}? </span>
			<br />
			<span> {{ data.item.value }} {{ data.type + '.DELETE_RELATED_WITH_CLIPS' | translate }} ( {{ itemRelatedClips }} ) </span>
		</div>

		<form [formGroup]="formGroup" class="row">
			<mat-form-field>
				<mat-label>{{ 'ASSORTED.SELECT_OPTION' | translate }}</mat-label>
				<input type="text" matInput formControlName="reassignTo" [matAutocomplete]="tagAutocomplete" [readonly]="formGroup.controls['reassign'].value" />
				<mat-autocomplete #tagAutocomplete="matAutocomplete" [displayWith]="displayFn.bind(this)">
					@for (filteredTag of filteredTags; track $index) {
					<mat-option [value]="filteredTag">{{ this.utils.getParameterByLanguageScript(filteredTag, 'name', true) || filteredTag.value }}</mat-option>
					}
				</mat-autocomplete>
			</mat-form-field>

			<div class="row pb-0">
				<mat-checkbox class="mt-2" color="primary" formControlName="reassign">
					<span>{{ data.type + '.REASSIGN_CONFIRMATION' | translate }}</span>
				</mat-checkbox>
			</div>
		</form>
		} @else if (data.mode === 'PENDING') {
		<div class="d-flex justify-content-center">
			<mat-spinner diameter="30"></mat-spinner>
		</div>
		}
	</mat-dialog-content>

	<mat-dialog-actions [align]="'end'" class="px-3">
		<mat-divider class="w-100 my-2"></mat-divider>
		@if (data.mode === 'DELETE' || data.mode === 'DELETE_REASSIGN') {
		<div class="d-flex justify-content-end pt-0">
			<button
				mat-flat-button
				color="warn"
				(click)="action()"
				[disabled]="apiLoading.management || (data.mode === 'DELETE_REASSIGN' && !(formGroup.controls['reassignTo'].value || formGroup.controls['reassign'].value))">
				<div class="d-flex">
					@if(apiLoading.management) {
					<mat-spinner diameter="15" class="me-1"></mat-spinner>
					}
					<span>{{ 'ASSORTED.YES' | translate }}</span>
				</div>
			</button>
			<button mat-flat-button color="primary" (click)="closeDialog()" [disabled]="apiLoading.management">
				{{ 'ASSORTED.NO' | translate }}
			</button>
		</div>
		} @else if (data.mode !== 'PENDING') {
		<button mat-flat-button color="primary" (click)="action()" [disabled]="formGroup.invalid || apiLoading.management">
			<div class="d-flex">
				@if(apiLoading.management) {
				<mat-spinner diameter="15" class="me-1"></mat-spinner>
				}
				<span>{{ 'BUTTON.SAVE' | translate }}</span>
			</div>
		</button>
		}
	</mat-dialog-actions>
</div>
